<template>
  <div class="box-tab">
    <div id="accordion">
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES37UC3']['10'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES37UC3']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="coddesc_codempid" name="coddesc_codempid">{{ detail.codempid }} - {{ detail.desc_codempid }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES37UC3']['30'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="dtereq" name="dtereq">{{ setDateOutput(detail.dtereq) }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES37UC1']['35'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="numseq" name="numseq">{{ detail.numseq }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES37UC3']['40'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70 txtarea-width response-full-width" id="desnote" name="desnote">{{ detail.desnote }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES37UC3']['50'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="dteuse" name="dteuse">{{ setDateOutput(detail.dteuse) }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES37UC3']['60'] }}</div>
                <div class="detail-right ">
                    
                  <input type="radio" name="flginc1" v-model="detail.flginc" value="Y" disabled="disabled"> <span class="radio-text">{{ labels['HRES37UC3']['70'] }}</span>
                  <input type="radio" name="flginc2" v-model="detail.flginc" value="N" disabled="disabled"> <span class="radio-text">{{ labels['HRES37UC3']['80'] }}</span>
                  <!-- <input type="radio" name="flginc1" value="1" disabled="disabled" <?php echo genValue($value, 'flginc') == "Y" ? "checked" : "";?>> <span class="radio-text"><?php echo genLabel($label, "HRES37UC3", "70");?></span> -->
                  <!-- <input type="radio" name="flginc2" value="2" disabled="disabled" <?php echo genValue($value, 'flginc') == "Y" ? "" : "checked";?>> <span class="radio-text"><?php echo genLabel($label, "HRES37UC3", "80");?></span> -->
                   
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES37UC3']['90'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="typcer" name="typcer">{{ detail.typcer }}</div>
                </div>
              </div>         

            </div>
          </div>

        </div>
      </div>
    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres37u-detail',
  props: [ 'labels', 'detail', 'toggle', 'data', 'nowLang', 'labelsButton' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?ff56aab8